'use client'

import { type ComponentProps, type FC } from 'react'

import {
  RecommendationHorizontalSlider,
  type RecommendationServiceType,
} from '../../../recommendation'

import { StoryblokRecommendationWidgetRenderer } from './StoryblokRecommendationAreaRenderer'

type StoryblokRecommendationSliderRendererProps = {
  cid?: string
  editableProps?: ComponentProps<'div'>
  serviceId: RecommendationServiceType
  widgetId: string
}

export const StoryblokRecommendationSliderRenderer: FC<
  StoryblokRecommendationSliderRendererProps
> = ({ cid, editableProps, serviceId, widgetId }) => {
  return (
    <StoryblokRecommendationWidgetRenderer
      cid={cid}
      editableProps={editableProps}
      renderProducts={({ onGtmDataLayerPush, widgetData }) => (
        <RecommendationHorizontalSlider
          onGtmDataLayerPush={onGtmDataLayerPush}
          products={widgetData?.content}
          productsPerPage={4}
        />
      )}
      serviceId={serviceId}
      widgetId={widgetId}
    />
  )
}
